module.exports = __webpack_public_path__ + "img/news18_2.b7d94ef5.jpg";